export const StepBack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <path d="M20.625 20.625V9.375H18.75V20.625H20.625ZM16.875 20.625L7.5 15L16.875 9.375V20.625ZM15 17.3203V12.6797L11.1328 15L15 17.3203Z" />
    </svg>
  );
};
